import { OptionIcon } from '@app/src/components/Form/Select'
import { FinalRiskRatingIcon } from '@app/src/components/Table/Cells/FinalRiskRatingCell'
import Filter from '@app/src/pages/ResourceCollection/Filters/Filter'
import FilterSelect from '@app/src/pages/ResourceCollection/Filters/FilterSelect'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { ProviderStandardCategoryNames } from '@app/src/types/categories'
import { getProviderCategoryOptions } from '@app/src/utils/providerCategoryOptions'
import { Chip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const FinalRiskRatingFilterSelect: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Filter operator={Operators.In} name={ProviderStandardCategoryNames.FinalRiskRating}>
      {({ value, onChange, filterName }) => (
        <FilterSelect
          size="small"
          multiple
          renderOption={(props, option, { selected }): JSX.Element => (
            <li {...props}>
              <OptionIcon selected={selected} multiple />
              <FinalRiskRatingIcon value={option?.label} />
              {option?.label !== undefined
                ? formatMessage({ id: `schemas.provider.finalRiskRatingValues.${option.label}` })
                : ''}
            </li>
          )}
          options={
            getProviderCategoryOptions(filterName)?.map(categoryOption => ({
              label: String(categoryOption),
              value: categoryOption,
            })) ?? []
          }
          renderTags={(value, getTagProps) =>
            value?.map(
              (option, index) =>
                option && (
                  <Chip
                    {...getTagProps({ index })}
                    key={option.value.toString() || index}
                    icon={<FinalRiskRatingIcon value={option.label} />}
                    label={formatMessage({ id: `schemas.provider.finalRiskRatingValues.${option.label}` })}
                    size="small"
                  />
                ),
            )
          }
          onChange={value => onChange(value)}
          fieldLabel={formatMessage({ id: 'schemas.provider.finalRiskRating' })}
          value={[value].flat()}
        />
      )}
    </Filter>
  )
}

export default FinalRiskRatingFilterSelect
